import { LaneType } from 'common-types';

export enum ApiKeyStatusEnum {
  Active = 'Active',
  Disabled = 'Disabled',
}

export type ApiKeyType = {
  _id: LaneType.UUID;
  _created: Date;
  _createdBy: LaneType.UUID;
  _updated: Date;
  _updatedBy: LaneType.UUID;
  _lastUsed: Date;
  userId: LaneType.UUID;
  title: string;
  description: string | null;
  apiKey: string;
  first4Chars: string;
  status: string;
};
